import { Component } from '@angular/core';

@Component({
    selector: 'app-about',
    templateUrl: './about.component.html',
    styleUrl: './about.component.scss',
    standalone: false,
  host: {
    class: 'row flex-grow-1'
  }
})
export class AboutComponent {

}
